module.exports = __webpack_public_path__ + "img/logo-10.42ea36fa.png";